import { createApp } from 'vue'
import App from './JoinBenefit.vue'

createApp(App).mount('#app-join-benefit')
